import { useEffect } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import FenceHero from './components/FenceHero';
import FenceServices from './components/FenceServices';
import FenceTypesElPaso from './components/FenceTypesElPaso';
import ContractorDirectory from './components/ContractorDirectory';
import ComparisonChecklist from './components/ComparisonChecklist';
import FenceFAQ from './components/FenceFAQ';

const Fence = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <FenceHero />
      <FenceServices />
      <FenceTypesElPaso />
      <ContractorDirectory />
      <ComparisonChecklist />
      <FenceFAQ />
      <Footer />
    </div>
  );
};

export default Fence;
